import Vue from "vue";
import VueRouter from "vue-router";
import Index from "../Index.vue";
import Development from "@/views/Development.vue";
import API from "@/views/api.vue";
import HELP from "@/views/helpCenter.vue"

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "index",
    component: Index,
    children: [
      {
        path: "/DOC/:filename",
        name: "DOC",
        component: Development,
      },
      {
        path: "/API/:version",
        name: "API",
        component: API,
      },
      {
        path: "/HELP/:filename",
        name: "HELP",
        component: HELP,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
